import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubmitApplication = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "submitApplication",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17359",
		"data-name": "Group 17359",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12810",
				"data-name": "Path 12810",
				d: "M18,8V5a2,2,0,0,0-2-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H8",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12811",
				"data-name": "Path 12811",
				d: "M7.5,17h0A1.5,1.5,0,0,1,6,15.5H6A1.5,1.5,0,0,1,7.5,14h0A1.5,1.5,0,0,1,9,15.5H9A1.5,1.5,0,0,1,7.5,17Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12812",
				"data-name": "Path 12812",
				d: "M21,19.586v-.865a1,1,0,0,0-.684-.949L18,17V15l.7-.446a1.387,1.387,0,0,0,.587-1.542h0A1.386,1.386,0,0,0,17.949,12h-2.9a1.386,1.386,0,0,0-1.335,1.012h0a1.387,1.387,0,0,0,.587,1.542L15,15v2l-2.316.772a1,1,0,0,0-.684.949v.865a1,1,0,0,0,.293.707l.414.414a1,1,0,0,0,.707.293h6.172a1,1,0,0,0,.707-.293l.414-.414A1,1,0,0,0,21,19.586Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12813",
				"data-name": "Path 12813",
				d: "M6,7h8",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12814",
				"data-name": "Path 12814",
				d: "M6,10.5h4",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12815",
		"data-name": "Path 12815",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgSubmitApplication;
